import MeliaLetMeMap from './widget/MeliaLetMeMap';

// Import and set here a Widget subclass to define 
// custom widget behaviour, components and layers for the project
// Rename SeedWidget to something more project related too, please;)
module.exports = new MeliaLetMeMap();




// WEBPACK FOOTER //
// ./src/app.js